import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useState, useLayoutEffect } from "react";
import toast from "react-hot-toast";
import { getDashboardData } from "services/other/dashboardController";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  //**********getting dashboard data**********/
  const getdashboardData = async () => {
    try {
      showLoader();
      const res = await getDashboardData();
      hideLoader();
      if (res.code === 200) {
        setDashboardData(res.data || {});
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  useLayoutEffect(() => {
    getdashboardData();
    // eslint-disable-next-line
  }, []);

  useLayoutEffect(() => {
    getDashboardData();
    // eslint-disable-next-line
  }, []);
  
  return (
    <React.Fragment>
      <title>श्री दत्त मंदिर संस्थान श्री क्षेत्र रुईभर</title>
      <div className="dashboard_home">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <h4 className="Title">Dashboard</h4><br/>
            {loader}
            <div className="row my-6">
              <div className="col-md-5">
                <div className="box text-center" style={{ height: "150px" }}>
                  <h5>Total Donations</h5>
                  <h4 style={{marginTop:"20px"}}>{dashboardData.totalCount || 0}</h4>
                </div>
              </div>

              <div className="col-md-5">
              <div className="box text-center" style={{ height: "150px" }}>
                  <h5>Total Donation Amount</h5>
                  <h4 style={{marginTop:"20px"}}>{dashboardData.totalAmount || 0}</h4>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
